import { render, staticRenderFns } from "./MoverNotas.vue?vue&type=template&id=454c4d5b"
import script from "./MoverNotas.vue?vue&type=script&lang=js"
export * from "./MoverNotas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports